import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { DIVIDEND_INVALIDATION_KEYS } from './dividend-invalidation.const';
import { CreateDividendDto } from './use-dividend-create.hook';

type UpdateDividendDto = {
  id: string;
  payload: Omit<CreateDividendDto, 'type'>;
};

export const useDividendUpdate = () => {
  const { invalidateQuery } = useInvalidateQueries(...DIVIDEND_INVALIDATION_KEYS);

  const { isPending, mutate: update } = useAppMutation<unknown, unknown, UpdateDividendDto>(
    [QueryKey.UPDATE_DIVIDEND_PAYOUT],
    {
      mutationFn: ({ id, payload }) =>
        ApiService.patch({ endpoint: BackendRoute.DIVIDENDS, routePath: [id] }, { body: payload }),
      onSuccess: () => {
        invalidateQuery();
      },
    },
  );

  return { isPending, update };
};
